$ = require 'jquery'
CardView = require 'views/card/card-view'
{ maybeDisplayCardLimitsError } = require 'views/card/card-limits-error'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
Dialog = require 'views/lib/dialog'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/archived_card_options'

track = require 'debug/track'

module.exports = class ArchivedCardView extends View
  tagName: 'div'

  className: 'archived-list-card'

  events:
    'click .list-card': 'openCard'
    'click .js-delete': 'deleteModel'
    'click .js-reopen': 'reopen'

  vigor: @VIGOR.NONE

  renderOnce: ->
    cardView = @subview(CardView, @model, { dontFilter: true })
    cardView.render()
    @$el.append cardView.el
    @$el.append template({
      editable: @model.editable(),
      canDelete: @options.canDelete
      canReopen: @model.getList()?
      reOpenText: @options.reOpenText
    })
    @

  openCard: (e) ->
    Util.stop(e)
    Controller.showCardDetail(@model)
    Dialog.calcPos()
    return

  deleteModel: (e) ->
    Util.stop(e)
    Confirm.toggle 'delete card',
      elem: $(e.target).closest('.js-delete')?[0]
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.destroy()
        track("Card", "Delete", "Via Archive")
    return

  reopen: (e) ->
    Util.preventDefault(e)
    if maybeDisplayCardLimitsError(e, @model.getBoard(), @model.getList())
      return

    @model.update { closed: false }, =>
      track('Card', "Reopen", "Via Archive")
    false



// WEBPACK FOOTER //
// ./app/scripts/views/archive/archived-card-view.coffee